export default {
  CLOSE_MENU: "header/CLOSE_MENU",
  OPEN_MY_BETS: "header/OPEN_MY_BETS",
  SET_BETS_COUNT: "header/SET_BETS_COUNT",
  SET_BODY_CLASS_NAME: "header/SET_BODY_CLASS_NAME",
  TOGGLE_DROP_DOWN: "header/TOGGLE_DROP_DOWN",
  SET_HEADER_HEIGHT: "header/SET_HEADER_HEIGHT",
  COLLAPSE_CROSS_ACTIVITY: "header/COLLAPSE_CROSS_ACTIVITY"
};
